import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { AsyncJobNamespace, AsyncJobReducer } from './store/async-job.store';

@NgModule({
  imports: [StoreModule.forFeature(AsyncJobNamespace, AsyncJobReducer)],
})
export class AsyncJobDataModule {}
